import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import moment from 'moment';

export default class DoveBadge extends WritingBadge {
  public readonly id = BadgeId.dove;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const hour = moment(stats.todaysPage.startedWritingAt)
      .toDate()
      .getHours();
    return hour <= 7 && hour >= 5;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/dove.ts